export const MEETING_OPTIONS = [
    { value: 'all', label: 'All'},
    { value: 'past', label: 'Past'},
    { value: 'upcoming', label: 'Upcoming'},
]
